const XIMENA_WISHLIST_KEY = 'ximena:wishlist:v1';
const XIMENA_WISHLIST_LIMIT = 50;

function normalizeXimenaWishlist(items) {
  if (!Array.isArray(items)) return [];

  const seen = new Set();
  return items
    .filter((item) => {
      if (!item || typeof item !== 'object') return false;
      const id = String(item.id || '');
      if (!/^\d+$/.test(id) || seen.has(id)) return false;
      if (typeof item.title !== 'string' || !item.title.trim()) return false;
      if (typeof item.url !== 'string' || !/^\/(?:collections\/[^/?#]+\/)?products\/[^/?#]+(?:[?#].*)?$/.test(item.url)) return false;
      seen.add(id);
      return true;
    })
    .map((item) => ({
      id: String(item.id),
      title: item.title.trim().slice(0, 300),
      vendor: typeof item.vendor === 'string' ? item.vendor.trim().slice(0, 150) : '',
      url: item.url,
      image: typeof item.image === 'string' ? item.image.slice(0, 2048) : '',
    }))
    .slice(0, XIMENA_WISHLIST_LIMIT);
}

let ximenaWishlistItems = [];
let ximenaWishlistOpener = null;

function readXimenaWishlist() {
  try {
    return normalizeXimenaWishlist(JSON.parse(localStorage.getItem(XIMENA_WISHLIST_KEY) || '[]'));
  } catch {
    return ximenaWishlistItems;
  }
}

function syncXimenaWishlistButton(button) {
  if (!button) return;
  const saved = ximenaWishlistItems.some((item) => item.id === button.dataset.productId);
  const title = button.dataset.productTitle || 'produsul';
  button.setAttribute('aria-pressed', String(saved));
  button.setAttribute('aria-label', `${saved ? 'Elimină' : 'Adaugă'} ${title} ${saved ? 'din' : 'la'} favorite`);
  button.querySelector('[data-wishlist-label]').textContent = saved ? 'Salvat' : 'Favorite';
}

function safeXimenaWishlistImage(value) {
  try {
    const url = new URL(value, location.origin);
    if (url.protocol === 'https:' && url.origin === location.origin) return url.href;
  } catch {}
  return '';
}

function renderXimenaWishlist() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(syncXimenaWishlistButton);
  document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
    count.textContent = ximenaWishlistItems.length;
    count.hidden = ximenaWishlistItems.length === 0;
  });
  document.querySelectorAll('[data-wishlist-open]').forEach((button) => {
    button.setAttribute('aria-label', `Deschide favoritele (${ximenaWishlistItems.length})`);
  });

  const drawer = document.querySelector('[data-wishlist-drawer]');
  const list = drawer?.querySelector('[data-wishlist-list]');
  if (!drawer || !list) return;

  drawer.querySelector('[data-wishlist-drawer-count]').textContent = `(${ximenaWishlistItems.length})`;
  drawer.querySelector('[data-wishlist-empty]').hidden = ximenaWishlistItems.length > 0;
  list.replaceChildren();

  ximenaWishlistItems.forEach((item) => {
    const row = document.createElement('li');
    const link = document.createElement('a');
    const media = document.createElement('span');
    const text = document.createElement('span');
    const title = document.createElement('strong');
    const remove = document.createElement('button');
    const imageUrl = safeXimenaWishlistImage(item.image);

    row.className = 'ximena-wishlist-drawer__item';
    link.className = 'ximena-wishlist-drawer__product';
    link.href = item.url;
    media.className = 'ximena-wishlist-drawer__media';
    text.className = 'ximena-wishlist-drawer__text';
    title.textContent = item.title;

    if (imageUrl) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = item.title;
      image.loading = 'lazy';
      image.width = 96;
      image.height = 96;
      media.append(image);
    } else {
      media.textContent = 'Fără imagine';
    }

    if (item.vendor) {
      const vendor = document.createElement('span');
      vendor.textContent = item.vendor;
      text.append(vendor);
    }
    text.append(title);
    link.append(media, text);

    remove.type = 'button';
    remove.className = 'ximena-wishlist-drawer__remove';
    remove.dataset.wishlistRemove = item.id;
    remove.textContent = 'Elimină';
    remove.setAttribute('aria-label', `Elimină ${item.title} din favorite`);
    row.append(link, remove);
    list.append(row);
  });
}

function writeXimenaWishlist(items) {
  ximenaWishlistItems = normalizeXimenaWishlist(items);
  try {
    localStorage.setItem(XIMENA_WISHLIST_KEY, JSON.stringify(ximenaWishlistItems));
  } catch {}
  renderXimenaWishlist();
}

function initXimenaWishlist() {
  ximenaWishlistItems = readXimenaWishlist();

  if (!customElements.get('ximena-wishlist-toggle')) {
    customElements.define(
      'ximena-wishlist-toggle',
      class XimenaWishlistToggle extends HTMLElement {
        connectedCallback() {
          syncXimenaWishlistButton(this.querySelector('[data-wishlist-toggle]'));
        }
      }
    );
  }

  renderXimenaWishlist();
  const drawer = document.querySelector('[data-wishlist-drawer]');

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const id = toggle.dataset.productId;
      const saved = ximenaWishlistItems.some((item) => item.id === id);
      writeXimenaWishlist(
        saved
          ? ximenaWishlistItems.filter((item) => item.id !== id)
          : [
              {
                id,
                title: toggle.dataset.productTitle,
                vendor: toggle.dataset.productVendor,
                url: toggle.dataset.productUrl,
                image: toggle.dataset.productImage,
              },
              ...ximenaWishlistItems,
            ]
      );
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      ximenaWishlistOpener = event.target.closest('[data-wishlist-open]');
      renderXimenaWishlist();
      if (!drawer.open) drawer.showModal();
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      writeXimenaWishlist(ximenaWishlistItems.filter((item) => item.id !== remove.dataset.wishlistRemove));
      drawer.querySelector('[data-wishlist-close]').focus();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) drawer.close();
  });

  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) drawer.close();
  });
  drawer.addEventListener('close', () => ximenaWishlistOpener?.focus());
  window.addEventListener('storage', (event) => {
    if (event.key !== XIMENA_WISHLIST_KEY) return;
    try {
      ximenaWishlistItems = normalizeXimenaWishlist(JSON.parse(event.newValue || '[]'));
    } catch {
      ximenaWishlistItems = [];
    }
    renderXimenaWishlist();
  });
}

if (typeof document !== 'undefined') initXimenaWishlist();
